import React from "react";
import { observer } from "mobx-react";

import { THEME_SETTINGS } from "@theme-settings";

import {
	TvCoverageButton,
	FavoritesButton,
	WidgetToggleButton,
	LiveStreamToggleButton,
} from "@features/offer/desktop/buttons";

export const EventFullInfoHeaderActions = observer(
	function EventFullInfoHeaderActions() {
		return (
			<div className="event__top__actions">
				{THEME_SETTINGS.features.media.isLiveStreamEnabled && (
					<LiveStreamToggleButton isOnEventView isOfferButton />
				)}
				{THEME_SETTINGS.features.media.isLiveMatchTrackerEnabled && (
					<WidgetToggleButton isOnEventView />
				)}

				<TvCoverageButton isOnEventView />

				<FavoritesButton isOfferButton={false} />
			</div>
		);
	}
);
